<svg:use [attr.fill]="fill" [attr.stroke]="stroke" [attr.href]="'#'+symbol" [attr.width]="w" [attr.height]="height"></svg:use>
